import styled from 'styled-components';

import Heading from 'components/_core/Heading';

export const ItemBadge = styled.div`
  display: flex;
`;

export const ItemMiddle = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacings.abs16}px;
`;

export const ListContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs48}px;
`;

export const DirectDebitMandateOldIbanWarningContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const Title = styled(Heading).attrs({
  size: 'lg',
})``;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
  flex-wrap: wrap;
  column-gap: ${({ theme }) => theme.spacings.abs8}px;
  row-gap: ${({ theme }) => theme.spacings.abs8}px;
`;
